import { API_ORIGIN } from 'constants/api';
import axios from 'axios';

/**
 * API call to validate token
 *
 * @method validateToken
 * @param  {string}        token The email token
 * @return {Promise}
 */
export function validateToken(token) {
    return axios({
        baseURL: API_ORIGIN,
        method : 'get',
        url    : `/v2/signatures/token/${token}`
    });
}

/**
 * API call to fetch the signing url via a given token.
 *
 * @method fetchSigningUrl
 * @param  {string}        token The email token
 * @return {Promise}
 */
export function fetchSigningUrl(token) {
    return axios({
        baseURL: API_ORIGIN,
        method : 'get',
        url    : `/v2/signatures/token/${token}/embeddedSigningURL`
    });
}

/**
 * API call to fetch the handbook pdf url via a given token.
 *
 * @method fetchPdfUrl
 * @param  {string}        token The email token
 * @return {Promise}
 */
export function fetchPdfUrl(token) {
    return axios({
        baseURL     : API_ORIGIN,
        method      : 'get',
        url         : `/v2/sign-documents/token/${token}/download`,
        responseType: 'blob'
    });
}
